module.exports = __webpack_public_path__ + "static/media/clock.662f6f0a.png";